export default {
  namespaced: true,
  state: {
    isOpen: false
  },
  mutations: {
    toggleOpen (state) {
      state.isOpen = !state.isOpen
    }
  },
  actions: {
    toggle ({ commit }) {
      commit('toggleOpen')
    }
  }
}
